import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { MdPerson, MdPersonOutline } from 'react-icons/lib/md';
import  ReactTooltip from 'react-tooltip';

import { formatPhoneNumber, formatEmail } from '../../utils/';
import { setAELookAEServProjId, setCurrentTabIndex } from '../../actions/additional_actions';
import { isActiveEmployee } from '../../utils/team';

class ProjectCardAE extends Component {
    // static PropTypes = {
    //     project: PropTypes.object.isRequired,
    //     onChangeWatch: PropTypes.func.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
        }
    }

    redirectToProjectAEtab(projectId) {
        this.props.setCurrentTabIndex(7);
        this.setState({redirect: true, projectId: projectId});
      }

    
    renderMembersAE(membersAE) {
        return membersAE.slice(0, 3).map((member) => {
            const fullName = member.members_AE.employee.firstName + ' ' + member.members_AE.employee.lastName;
            return (
                <div key={member.id} className="col s12">
                    <h6>{member.isTeamLeader ? 'Team Leader' : 'Team Member'}</h6>
                    <span>
                        {
                            isActiveEmployee(member.members_AE.employee) && <MdPerson className='user-icon active-user' data-for='user-icon' data-tip="In DDC"/>
                        }
                        {
                            isActiveEmployee(member.members_AE.employee) === false && <MdPersonOutline className='user-icon inactive-user' data-for='user-icon' data-tip="Not in DDC"/>           
                        }
                        {
                            isActiveEmployee(member.members_AE.employee) === null && <MdPersonOutline className='user-icon' data-for='user-icon' data-tip="Status Unknown"/>           
                        }
                        {fullName}
                    </span>
                    {formatEmail(member.members_AE.employee.email)}
                    {formatPhoneNumber(member.members_AE.employee.telExtension)}
                    <ReactTooltip id='user-icon'/>
                </div>
            );
        });
    }

    render() {
        const { project, pmReqAEServProjId } = this.props;
        const membersAE = project.trackingMembers_AE;

        if (pmReqAEServProjId === project.projectId) {
            this.props.dispatch(setAELookAEServProjId(pmReqAEServProjId));
        }

        if (this.state.redirect) {
            const path = `/projects/${project.projectId}`;
            return <Redirect push={true} to={path} />;
        }

        return (
            <div>
                <div className="card">

                    <div className="card-left"
                    onClick={() => this.redirectToProjectAEtab(project.projectid)}>

                        <div className="categories">
                            {project.divisionName} / {project.projectType}
                        </div>
                        <h4>
                            {project.projectId}
                            <span className="separator" />
                            {project.projectDescription}
                        </h4>

                        <p><strong>Current A&E Phase:</strong>
                            {(project.mainTracking_AE.length > 0 && project.mainTracking_AE[0].lkp_Phase_AE1 != null && project.mainTracking_AE[0].lkp_Phase_AE1.phaseName !== '' && project.mainTracking_AE[0].lkp_Phase_AE1.phaseName !== undefined)
                                ? project.mainTracking_AE[0].lkp_Phase_AE1.phaseName
                                : null}</p>

                        <p className="fmsids">
                            <strong>FMS ID:</strong>{' '}
                            {project.fmsids.map(f => f.fmsid).join(', ')}
                        </p>

                        <div className="margin-top-075">
                            <p><strong>Track:</strong>
                                {(project.mainTracking_AE.length > 0 && project.mainTracking_AE[0].lkp_Track_AE && project.mainTracking_AE[0].lkp_Track_AE.track)}
                            </p>

                            <p><strong>Current Queue:</strong>
                                {(project.mainTracking_AE.length > 0 && project.mainTracking_AE[0].queueTypeId === 1)
                                    ? 'PM'
                                    : 'A&E'}
                            </p>

                            <p><strong>Discipline:</strong>
                        {(project.mainTracking_AE.length > 0 && project.mainTracking_AE[0].lkp_Discipline_AE!==null && project.mainTracking_AE[0].lkp_Discipline_AE.discipline)}
                            </p>

                            <p><strong>Design Source:</strong>
                            {(project.mainTracking_AE.length > 0 && project.mainTracking_AE[0].lkp_DesignSource_AE !== null && project.mainTracking_AE[0].lkp_DesignSource_AE.designSource)}
                            </p>

                        </div>
                    </div>

                    <div className="card-right">
                        <div className="categories aeCategories">Project Team</div>
                        <div className="row card-details">
                            {membersAE !== null ? this.renderMembersAE(membersAE) : null}
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

ProjectCardAE.propTypes = {
    project: PropTypes.object.isRequired,
    onChangeWatch: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
    return {}
}

export default connect(mapStateToProps, {setCurrentTabIndex} )(ProjectCardAE);